import { Controller } from "stimulus";

// Online-sale tab behaviour: availability toggle (config + readiness variants), the plan
// picker dropdown (open/close/filter) and the inline unlink confirmation.
// Self-contained so it works inside any form (course basic/curriculum, activity).
export default class extends Controller {
  static targets = ['flag', 'config', 'whenActive', 'whenInactive',
                    'picker', 'pickerSearch', 'pickerItem', 'pickerEmpty'];

  connect() {
    // Close the picker when clicking anywhere outside it (except its own open buttons).
    this.boundClosePicker = (event) => {
      if (!this.hasPickerTarget || this.pickerTarget.classList.contains('hidden')) return;
      if (this.pickerTarget.contains(event.target) || event.target.closest('[data-online-sale-picker-open]')) return;
      this.closePicker();
    };
    document.addEventListener('mousedown', this.boundClosePicker);
  }

  disconnect() {
    document.removeEventListener('mousedown', this.boundClosePicker);
  }

  toggle() {
    if (!this.hasFlagTarget)
      return;

    const active = this.flagTarget.checked;
    if (this.hasConfigTarget)
      this.configTarget.classList.toggle('hidden', !active);

    this.whenActiveTargets.forEach((element) => element.classList.toggle('hidden', !active));
    this.whenInactiveTargets.forEach((element) => element.classList.toggle('hidden', active));
  }

  openPicker() {
    if (!this.hasPickerTarget) return;

    this.pickerTarget.classList.remove('hidden');
    if (this.hasPickerSearchTarget) this.pickerSearchTarget.focus();
  }

  closePicker() {
    if (this.hasPickerTarget) this.pickerTarget.classList.add('hidden');
  }

  filterPicker() {
    const query = this.pickerSearchTarget.value.trim().toLowerCase();
    let visibleCount = 0;

    this.pickerItemTargets.forEach((item) => {
      const matches = item.dataset.planName.includes(query);
      item.classList.toggle('hidden', !matches);
      if (matches) visibleCount += 1;
    });

    if (this.hasPickerEmptyTarget) this.pickerEmptyTarget.classList.toggle('hidden', visibleCount > 0);
  }

  // The unlink confirmation is row-scoped ([data-unlink] wraps each pair), so the same
  // controller instance serves every linked-plan row.
  askRemoval(event) {
    const row = event.currentTarget.closest('[data-unlink]');
    if (!row) return;

    row.querySelector('[data-unlink-ask]').classList.add('hidden');
    const confirmation = row.querySelector('[data-unlink-confirm]');
    confirmation.classList.remove('hidden');
    confirmation.classList.add('inline-flex');
  }

  cancelRemoval(event) {
    const row = event.currentTarget.closest('[data-unlink]');
    if (!row) return;

    row.querySelector('[data-unlink-ask]').classList.remove('hidden');
    const confirmation = row.querySelector('[data-unlink-confirm]');
    confirmation.classList.add('hidden');
    confirmation.classList.remove('inline-flex');
  }
}
